export const SET_PAYMENT_METHOD_AND_CHECKOUT = "SET_PAYMENT_METHOD_AND_CHECKOUT";
export const CREATE_PAYMENT_INTENT = "CREATE_PAYMENT_INTENT";
export const GET_PLANS = 'GET_PLANS'
export const GET_PRORATION = 'GET_PRORATION'
export const SUBSCRIPTION_UPGRADE = 'SUBSCRIPTION_UPGRADE'
export const GET_ORDERS = 'GET_ORDERS'
export const CANCEL_SUBSCRIPTION= 'CANCEL_SUBSCRIPTION'
